import React from 'react';
import { Button } from '../Button';
import { routes } from '../../routeConfig';


import './index.scss';

export default function Footer (props: any){
    return (
        <div className='c_footer'>
            <div className='c_footer__buttons'>
                <Button link={routes.ApoyaMali.path} theme='dark'>
                    APOYAR
                </Button>
                <Button link={routes.AspectoLegal.path} theme='solid'>
                    LEGAL
                </Button>
            </div>
            <Button link={routes.QuienesSomos.path} className='c_footer__button' theme='solid'>
                MÁS INFORMACIÓN
            </Button>
            <img className='c_footer__logo' src="/images/mali.png"></img>
        </div>
    )
}